import React from "react"

import {hasProperty, formatText} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

import ViewConcept from './ViewConcept';
import ViewModel from './ViewConceptModel';
import ViewConceptModel from "./ViewConceptModel";


class ViewLink extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            noLinks: false,
        };


        this.dsd = new dsd();
        this.dsd.StateObject = this;

        this.data = {};
        this.data.Link = null;

        if (this.props.Link){
            this.data.Link = this.props.Link; 
        }

        if (this.props.noLinks){
            this.state.noLinks = this.props.noLinks; 
        }


        this.filters = {};

        this.columns = {
        };

        this.data.id = null;
        if (this.props.id){
            this.data.id = this.props.id; 
        }


    }

    componentDidMount() {

        if (this.data.Link){
            this.setState({"isLoaded":true});
            return;
        }

    };

    view(json){

        if (json){
            return(
                <PD.Table className="panel">
                    <PD.Tbody>

                        {hasProperty(json,'ConceptFrom') &&
                            <PD.Tr>                                
                                <PD.Th>From Concept</PD.Th>
                                <PD.Td>
                                    <ViewConcept Concept={json.ConceptFrom} noLinks={this.state.noLinks}/>
                                </PD.Td>
                            </PD.Tr>
                            
                        }

                        {hasProperty(json,'name') &&
                            <PD.Tr>                                
                                <PD.Th>Name</PD.Th>
                                <PD.Td>

                                    {(() => {
                                        switch (this.state.noLinks) {
                                            case true:
                                                return json.name
                                            default:
                                                return (
                                                    <PD.PdNavLink to={"/link/" + json._id} >
                                                        {json.name}
                                                    </PD.PdNavLink>
                                                )
                                        }
                                    })()}
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'ConceptTo') &&
                            <PD.Tr>                                
                                <PD.Th>To Concept</PD.Th>
                                <PD.Td><ViewConcept Concept={json.ConceptTo} noLinks={this.state.noLinks}/></PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'label') &&
                            <PD.Tr>                                
                                <PD.Th>Label</PD.Th><PD.Td>{json.label}</PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'inverseLabel') &&
                            <PD.Tr>                                
                                <PD.Th>Inverse Label</PD.Th><PD.Td>{json.inverseLabel}</PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'description') &&
                            <PD.Tr>
                                <PD.Th>Description</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.description}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'notes') &&
                            <PD.Tr>
                                <PD.Th>Notes</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.notes}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'proposals') &&
                            <PD.Tr>
                                <PD.Th>Proposals</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.proposals}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'status') &&
                            <PD.Tr>                                
                                <PD.Th>Status</PD.Th><PD.Td>{json.status}</PD.Td>
                            </PD.Tr>
                        }

                    </PD.Tbody>
                </PD.Table>
            )
        };
        return null;
    };

    render() {

        if (this.state.isLoaded) {

            return (
                <div>
                    {this.view(this.data.Link)}
                </div>
            )
        }
        else {
            return <div />;
        }

    };    
};
        
export default ViewLink;